/**
 * hex-geometry.ts — pure geometry for flat-top hexagons.
 * No React, no state — pure math functions only.
 */

import { TILE_POSITIONS } from "./tile-positions.js";

export const HEX_R = 22; // flat-top outer radius (viewBox px)
export const CANVAS_W = 900;
export const CANVAS_H = 540;

const DEG2RAD = Math.PI / 180;

/**
 * Returns the SVG polygon points string for a flat-top hexagon.
 * Vertices at angles k*60° starting at 0° (east).
 */
export function flatTopHexPoints(cx: number, cy: number, r: number): string {
  const pts: string[] = [];
  for (let k = 0; k < 6; k++) {
    const a = k * 60 * DEG2RAD;
    pts.push(`${(cx + r * Math.cos(a)).toFixed(2)},${(cy + r * Math.sin(a)).toFixed(2)}`);
  }
  return pts.join(" ");
}

/**
 * Returns the canvas-pixel center of a tile by index.
 * Reads from locked tile-positions.json — never recomputes.
 */
export function tileCenter(idx: number): { x: number; y: number } {
  const pos = TILE_POSITIONS[idx];
  if (pos === undefined) {
    throw new Error(`tileCenter: idx ${idx} out of range [0, ${TILE_POSITIONS.length})`);
  }
  return { x: pos.x * CANVAS_W, y: pos.y * CANVAS_H };
}
